import { generateUUID } from './uuid.js';
function key(prefix) {
    const uuid = generateUUID();
    if (prefix) {
        return `${prefix}_${uuid}`;
    }
    return uuid;
}
export default key;
//# sourceMappingURL=key.js.map